import { useContextSelector } from "use-context-selector";
import { cdnImg } from "../../Utils/cdnImage";
import ThemeContext from "../../context/ThemeContext";
import {
  AllCasinoPlatform,
  filterarcade,
  filtercasion,
  filtercrash,
  filterfishing,
  filterlotto,
  filterslot,
  filtertable,
} from "./ListHome";
import { isMobile } from "react-device-detect";
import { isEmpty } from "lodash";

const FilterCasino = ({
  active,
  setActiveInner,
  activeInner,
  setShow,
  setActive,
}) => {
  let object = {
    casino: filtercasion,
    slots: filterslot,
    table: filtertable,
    crash: filtercrash,
    fishing: filterfishing,
    arcade: filterarcade,
    lottery: filterlotto,
    all: AllCasinoPlatform,
  };

  let listArray = [
    { label: "All", key: "all" },
    { label: "Casino", key: "casino" },
    { label: "Slots", key: "slots" },
    { label: "Table", key: "table" },
    { label: "Crash", key: "crash" },
    { label: "Fishing", key: "fishing" },
    { label: "Arcade", key: "arcade" },
    { label: "Lottery", key: "lottery" },
  ];
  const unique = (array) => {
    return [...new Map(array.map((item) => [item.name, item])).values()];
  };

  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const getImageUrl = (url) => {
    return url;
  };
  return (
    <>
      <div className="ng-tns-c2684251700-888 ng-trigger ng-trigger-staggerFadeAnimation tab search-tab brand-tab ng-star-inserted">
        <ul className="item-ani ng-tns-c2684251700-888">
          <li
            onClick={() => setActiveInner("all")}
            className={`condition-groups ${activeInner == "all" ? "active" : ""}`}
          >
            <div
              className="icon-all ng-tns-c2684251700-888 ng-star-inserted"
              style={{
                backgroundImage:
                  theme == "dark"
                    ? `url("/assets/Icon/icon-filter-all.svg")`
                    : `url("/assets/IconDark/icon-filter-all-black.svg")`,
              }}
            />
          </li>
          {object[active]?.map((res) => {
            return (
              <li
                style={
                  isMobile
                    ? { width: "unset" }
                    : {
                        // flex: "0 0 7vw",
                        minWidth: "unset",
                      }
                }
                onClick={() => setActiveInner(res?.name)}
                className={`condition-groups ${
                  activeInner == res?.name ? "active" : ""
                }`}
              >
                <div
                  style={
                    !isMobile
                      ? {
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }
                      : {}
                  }
                  className="condition-groups__inner ng-tns-c2684251700-888 ng-star-inserted"
                >
                  <img
                    className="ng-tns-c2684251700-888"
                    alt="provider-awcmpt"
                    src={cdnImg(getImageUrl(res?.image))}
                    loading="lazy"
                  />
                  <div
                    style={{
                      display: "inline-flex",
                      color: "#ffb80c",
                      marginLeft: "8px",
                    }}
                    className="ng-tns-c2684251700-888"
                  >
                    {res?.name}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>

        {!isMobile && (
          <div
            onClick={() => setShow(true)}
            _ngcontent-serverapp-c2521702864
            className="btn search-btn ng-tns-c2521702864-98 ng-star-inserted"
            style={{}}
          >
            <span
              _ngcontent-serverapp-c2521702864
              className="item-icon ng-tns-c2521702864-98 ng-star-inserted"
              style={{
                maskImage: 'url("/assets/Icon/icon-search-type01.svg")',
              }}
            />
          </div>
        )}
      </div>

      <div className="ng-tns-c2684251700-888 ng-trigger ng-trigger-staggerFadeAnimation tab search-tab brand-tab ng-star-inserted">
        <ul className="item-ani ng-tns-c2684251700-888">
          {listArray?.map((res) => {
            return (
              <li
                style={
                  isMobile
                    ? { width: "unset", flex: "0 0 7vw" }
                    : {
                        flex: "0 0 7vw",
                        minWidth: "unset",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }
                }
                onClick={() => {
                  setActive(res?.key);
                  if (
                    isEmpty(
                      object[res?.key]?.find((res) => {
                        return res?.name == activeInner;
                      }),
                    )
                  ) {
                    if (res?.key !== "all") {
                      setActiveInner(object[res?.key][0]?.name);
                    } else {
                      setActiveInner("PP");
                    }
                  }
                }}
                className={`condition-groups ${
                  active == res?.key ? "active" : ""
                }`}
              >
                <div className="condition-groups__inner ng-tns-c2684251700-888 ng-star-inserted">
                  <div
                    style={{
                      color: "#ffb80c",
                    }}
                    className="ng-tns-c2684251700-888"
                  >
                    {res?.label}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default FilterCasino;
